import _ from 'lodash'
import moment from 'moment'
import timelineToGraphData from '../services/timeline/timeline'

export default routesConfig

const redirectSelfcareV2 = () => {
    if (window.location.host.indexOf('local') !== -1) {
        window.location = `https://local.unergie.com:3010/`
    } else {
        window.location = `https://${window.location.host}/v2`
    }
}

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider, $qProvider) {
    $stateProvider
    .state('home', {
        url: '?from&utm_source&utm_medium&utm_campaign',
        abstract: true,
        controller: 'homeCtrl',
        template: require('../states/home/home.jade')(),
        resolve: {
            features(featuresService) {
                return featuresService.getFeatures()
            },
        },
    })
    .state('offer', {
        url: '',
        abstract: true,
        parent: 'navbar',
        template: require('../states/offer/view.jade')(),
        controller: 'offerCtrl',
        data: {
            showFold: true,
        },
    })
    .state('landing', {
        url: '/',
        parent: 'home',
        template: require('../states/landing/landing.jade')(),
        controller: 'landingCtrl',
        params: {
            shouldOpenPriceForm: false,
        },
        data: {
            pageTitle: 'L’offre',
        },
        resolve: {
            defaultRedirection($state, $stateParams, $q, $window, PermPermissionStore, DeviceChecker) {
                const deferred = $q.defer()
                const isClient = __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission())

                isClient.then(() => {
                    if (DeviceChecker.isMobile()) {
                        $state.go('dashboard', { shouldOpenPriceForm: $stateParams.shouldOpenPriceForm })
                    } else {
                        $state.go('account', { shouldOpenPriceForm: $stateParams.shouldOpenPriceForm })
                    }
                    deferred.reject()
                })
                .catch(() => {
                    const isUser = __guard__(PermPermissionStore.getStore().user, (x) => x.validatePermission())
                    isUser.then(() => {
                        $state.go('community')
                        deferred.reject()
                    })
                    .catch(() => {
                        if ($window.location.host.indexOf('local') === -1) {
                            $window.location.href = `https://${$window.location.host}`
                            deferred.reject()
                        }
                        deferred.resolve()
                    })
                })
                return deferred.promise
            },
        },
    })
    .state('landingPrice', {
        url: '/tarifs',
        resolve: {
        // This is a hack - Need to use angular-ui-router: 1.0.0 minimum for better redirectTo
            redirectTo($state, $q) {
                $state.go('landing', { shouldOpenPriceForm: true })
                return $q.reject()
            },
        },
    })
    .state('whatsMyMeter', {
        parent: 'offer',
        url: '/offre/quel-est-mon-compteur',
        template: require('../states/whatsMyMeter/view.jade')(),
        data: {
            pageTitle: 'Quel est mon compteur',
            showHeader: false,
        },
    })
    .state('myMeter', {
        parent: 'offer',
        url: '/offre/compteur',
        template: require('../states/myMeter/view.jade')(),
        controller: 'myMeterCtrl',
        data: {
            showHeader: false,
        },
    })
    .state('myMeter.linky', {
        url: '/linky',
        template: require('../states/myMeter/linky.jade')(),
        data: {
            pageTitle: 'Compteur Linky',
        },
    })
    .state('myMeter.classique', {
        url: '/classique',
        template: require('../states/myMeter/classique.jade')(),
        data: {
            pageTitle: 'Compteur Classique',
        },
    })
    .state('login', {
        parent: 'home',
        url: '/me-connecter?source&redirectTo',
        template: require('../states/login/login.jade')(),
        params: {
            transactionStatus: null,
            transactionErrorCode: null,
            signatureOperationResult: null,
            transactionId: null,
            order_reference: null,
            processId: null,
            key: null,
            bulk_purchase: null,
        },
        controller: 'loginCtrl',
        data: {
            pageTitle: 'Me connecter',
            permissions: {
                only: [
                    'anonymous',
                ],
                redirectTo: 'landing',
            },
        },
        resolve: {
            redirectTo() {
                redirectSelfcareV2()
            }
        },
    })
    .state('logout', {
        parent: 'home',
        url: '/logout',
        controller: 'logoutCtrl',
        data: {
            pageTitle: 'Se déconnecter',
            permissions: {
                except: [
                    'anonymous',
                ],
                redirectTo: 'landing',
            },
        },
    })
    .state('forgotPassword', {
        parent: 'home',
        url: '/reinitialisation-mot-de-passe?source&redirectTo',
        template: require('../states/forgotPassword/forgotPassword.jade')(),
        controller: 'forgotPasswordCtrl',
        data: {
            pageTitle: 'Réinitialisez votre mot de passe',
            permissions: {
                only: [
                    'anonymous',
                ],
                redirectTo: 'landing',
            },
        },
    })
    .state('firstLogin', {
        parent: 'home',
        url: '/choix-mot-de-passe?source&redirectTo',
        template: require('../states/forgotPassword/forgotPassword.jade')(),
        controller: 'forgotPasswordCtrl',
        data: {
            pageTitle: 'Choisir votre mot de passe',
            permissions: {
                only: [
                    'anonymous',
                ],
                redirectTo: 'landing',
            },
        },
    })
    .state('signup', {
        parent: 'home',
        url: '/m-inscrire?source&redirectTo&parrainage&promo',
        template: require('../states/signup/signup.jade')(),
        controller: 'signupCtrl',
        data: {
            pageTitle: 'M’inscrire',
            permissions: {
                only: [
                    'anonymous',
                ],
                redirectTo(rejectedPermission, transitionProperties) {
                    return {
                        state: transitionProperties.toParams.redirectTo,
                    }
                },
            },
        },
    })
    .state('confirm', {
        parent: 'home',
        url: '/confirm-email?token&source&redirectTo',
        params: {
            transactionStatus: null,
            transactionErrorCode: null,
            signatureOperationResult: null,
            transactionId: null,
            order_reference: null,
            processId: null,
            key: null,
            bulk_purchase: null,
        },
        template: require('../states/confirm/confirm.jade')(),
        controller: 'confirmCtrl',
        data: {
            pageTitle: 'Confirmer email',
            permissions: {
                only: [
                    'anonymous',
                ],
                redirectTo: 'landing',
            },
        },
        resolve: {
            userInfo($stateParams, User, $q, ErrorCatcher) {
                return User.getInfoByToken({ token: $stateParams.token }).$promise
                .then((userInfo) => $q.resolve({ hasUserInfo: true }))
                .catch((error) => {
                    if (error.status !== 404) {
                        ErrorCatcher.catchError(error)
                    }
                    return $q.resolve({ hasUserInfo: false })
                })
            },
        },
    })
    .state('confirmChangeMail', {
        parent: 'home',
        url: '/modif-email/:processId?key',
        template: require('../states/confirmChangeMail/confirmChangeMail.jade')(),
        controller: 'confirmChangeMailCtrl',
        data: {
            pageTitle: 'Confirmer changement email',
            permissions: {
                only: [
                    'user',
                ],
                redirectTo(rejectedPermission, transitionProperties) {
                    return {
                        state: 'login',
                        params: _.assign({}, transitionProperties.toParams, { redirectTo: 'confirmChangeMail' }),
                    }
                },
            },
        },
        resolve: {
            isChangeMailSuccess($q, $stateParams, ErrorCatcher, User) {
                return User.confirmNewEmail({ processId: $stateParams.processId }, { key: $stateParams.key }).$promise
                .then(() => $q.resolve(true))
                .catch((error) => {
                    ErrorCatcher.catchErrorWithoutRedirect(error)
                    return $q.resolve(false)
                })
            },
        },
    })
    .state('navbar', {
        parent: 'home',
        url: '?contractId',
        abstract: true,
        controller: 'navbarCtrl',
        template: require('../states/navbar/navbar.jade')(),
        data: {
            showNavOnMobile: false,
        },
        resolve: {
            userInfo($stateParams, ApiService, PermPermissionStore) {
                return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
                .then(() => {
                    const userInfo$ = ApiService.fetchUserInfo()
                    if ($stateParams.contractId) {
                        return userInfo$.then((response) => {
                            const selectedContract = _.filter(response.contracts, { id: $stateParams.contractId })[0]
                            response.contractSelected = _.defaultTo(selectedContract, response.contractSelected)
                            return response
                        })
                    }
                    return userInfo$
                }))
            },
            pot(PotManager, PermPermissionStore) {
                return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
                .then(() => PotManager.getPotBalance())
                .catch(() => false))
            },
            userAction(User, PermPermissionStore) {
                return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
                .then(() => User.getUa())
                .catch(() => false))
            },
        },
    })
    .state('dashboard', {
        url: '/mon-tableau-de-bord',
        parent: 'navbar',
        params: {
            shouldOpenPriceForm: false,
        },
        data: {
            showNavOnMobile: true,
        },
    })
    .state('flow', {
        // parent: 'navbar'
        url: '/le-fil-plum-energie',
        template: require('../states/flow/flow.jade')(),
        controller: 'flowCtrl',
        data: {
            pageTitle: 'Le fil plüm énergie',
            permissions: {
                except: [
                    'anonymous',
                    'user',
                ],
                redirectTo: 'landing',
            },
        },
    })
    .state('hints', {
        parent: 'navbar',
        url: '/conseils',
        template: require('../states/hints/hints.jade')(),
        controller: 'hintsCtrl',
        params: {
            shouldOpenPriceForm: false,
        },
        resolve: {
            hints(Hint, ErrorCatcher, $q) {
                return Hint.getAll().$promise
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.reject(error)
                })
            },
        },
        data: {
            pageTitle: 'Les conseils',
            permissions: {
                only: [
                    'client',
                ],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'hints',
                        },
                    },
                    default: 'login',
                },
            },
        },
    })
    .state('tracking', {
        parent: 'navbar',
        url: '/suivi-conso',
        template: require('../states/tracking/tracking.jade')(),
        controller: 'trackingCtrl',
        data: {
            pageTitle: 'Mon suivi conso',
            permissions: {
                only: [
                    'client',
                ],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'tracking',
                        },
                    },
                    default: 'login',
                },
            },
        },
        resolve: {
            activeContract($q, $state, ContractStatus, userInfo) {
                if (userInfo.status !== ContractStatus.resilie) {
                    return $q.resolve(userInfo.contractSelected)
                }
                $state.go('landing')
                return $q.reject(userInfo.contractSelected)
            },
            contractCons(userInfo, Contract, featuresService, ErrorCatcher, $q) {
                const startDate = moment().subtract(6, 'months').format('MMYYYY')
                return featuresService.getFeaturesPromise().then((dataFeature) => {
                    const route = (dataFeature.myConsV2 === false) ? 'myCons' : 'myConsV2'

                    return Contract[route]({ id: userInfo.contractSelected.id, start: startDate }).$promise
                    .catch((error) => {
                        ErrorCatcher.catchError(error)
                        // return $q.reject(error)
                    })
                })
            },
            landscapeQuestions(ApiService, userInfo, LandscapeQuestions, ErrorCatcher, $q) {
                // will change when other merge will be approved
                return ApiService.fetchFeatures()
                .then((response) => {
                    if (response.landscape) {
                        let contractId
                        if (userInfo.contractSelected) {
                            contractId = userInfo.contractSelected.id
                        } else {
                            return false
                        }

                        const landscapeQs = LandscapeQuestions.search({ category: 'c-est-parti', id_contract: contractId })
                        return landscapeQs.$promise
                        .catch((error) => {
                            ErrorCatcher.catchError(error)
                            return $q.resolve([])
                        })
                    }
                    return true
                })
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.reject(error)
                })
            },
        },
    })
    .state('navbarAccount', {
        parent: 'navbar',
        abstract: true,
        controller: 'navbarAccountCtrl',
        template: require('../states/navbarAccount/navbarAccount.jade')(),
    })
    .state('account', {
        parent: 'navbarAccount',
        url: '/mon-compte',
        template: require('../states/account/account.jade')(),
        controller: 'accountCtrl',
        data: {
            pageTitle: 'Contrat',
            permissions: {
                only: [
                    'client',
                ],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'account',
                        },
                    },
                    default: 'login',
                },
            },
        },
        resolve: {
            redirectTo() {
                redirectSelfcareV2()
            },
            billingAddress(ApiService, User, ErrorCatcher, $q) {
                return User.getBillingAddress().$promise
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.reject(error)
                })
            },
        },
    })
    .state('invoice', {
        parent: 'navbarAccount',
        url: '/mes-factures?transactionStatus&transactionId',
        template: require('../states/invoice/invoice.jade')(),
        controller: 'invoiceCtrl',
        data: {
            pageTitle: 'Mes factures',
            permissions: {
                only: [
                    'client',
                ],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'invoice',
                        },
                    },
                    default: 'login',
                },
            },
        },
        resolve: {
            redirectTo() {
                redirectSelfcareV2()
            },
            invoices(userInfo, Contract, ErrorCatcher, $q) {
                return Contract.getInvoices({ id: userInfo.contractSelected.id }).$promise
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.resolve({ currentSituation: {}, invoices: [] })
                })
            },
            transaction($q, $stateParams, ErrorCatcher, Invoice, DataAccessVariables) {
                if (_.isEmpty($stateParams.transactionId)) {
                    return $q.resolve({})
                }
                const transactionResult = {
                    transactionStatus: $stateParams.transactionStatus,
                    transactionId: $stateParams.transactionId,
                }
                if ($stateParams.transactionId.split('_')[0] === 'DEPOSIT') {
                    return DataAccessVariables.get({ variables: 'DEPOSIT_AMOUNT' }).$promise.then((response) => {
                        return _.assign({}, transactionResult, { payment: { amount: response.DEPOSIT_AMOUNT } })
                    }).catch((error) => {
                        ErrorCatcher.catchError(error)
                        return transactionResult
                    })
                }
                return Invoice.getPayment({ payment_id: $stateParams.transactionId }).$promise.then((result) => {
                    return _.assign({}, result, { payment: result })
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    return transactionResult
                })
            },
        },
    })
    .state('personalInformation', {
        parent: 'navbarAccount',
        url: '/infos-personnelles',
        template: require('../states/personalInformation/personalInformation.jade')(),
        controller: 'personalInformationCtrl',
        data: {
            pageTitle: 'Info personnelles',
            permissions: {
                only: [
                    'client',
                ],
                redirectTo: {
                    client: {
                        state: 'login',
                        params: {
                            redirectTo: 'personalInformation',
                        },
                    },
                    default: 'login',
                },
            },
        },
    })
    .state('community', {
        parent: 'home',
        url: '/communaute?contact',
        template: require('../states/community/community.jade')(),
        controller: 'communityCtrl',
        data: {
            pageTitle: 'La communauté',
        },
    })
    .state('terms', {
        parent: 'home',
        url: '/mentions-legales',
        template: require('../states/terms/view.jade')(),
        controller: 'termsCtrl',
        data: {
            pageTitle: 'Mentions legales',
        },
        resolve: {
            providerInfo(ProviderInfo) {
                return ProviderInfo.get().$promise
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log('Cannot fetch provider info')
                })
            },
        },
    })
    .state('sponsor', {
        url: '/parrainage/:sponsorId',
        parent: 'home',
        controller: 'sponsorCtrl',
        data: {
            pageTitle: 'Sponsor',
        },
    })
    .state('promo', {
        url: '/promo/:promoId',
        parent: 'home',
        controller: 'promoCtrl',
        data: {
            pageTitle: 'Promo',
        },
    })
    .state('subscription', {
        url: '/old-souscription',
        params: {
            bulk_purchase: null,
        },
        resolve: {
            // This is a hack - Need to use angular-ui-router: 1.0.0 minimum for better redirectTo
            redirectTo($window, $stateParams) {
                const ufcQuery = $stateParams.bulk_purchase === 'ufc' ? `/achat-groupe?token=${localStorage.bulkPurchaseSubscriptionToken}` : ''
                if ($window.location.host.indexOf('local') !== -1) {
                    $window.location.href = `https://local.unergie.com:3008${ufcQuery}`
                } else {
                    $window.location.href = `https://${$window.location.host}/souscription${ufcQuery}`
                }
            },
        },
    })
    // .state('subscription', {
    //     url: '/souscription',
    //     template: require('../states/subscription/subscription.jade')(),
    //     parent: 'home',
    //     controller: 'subscriptionCtrl',
    //     resolve: {
    //         contractDraft($q, $stateParams, ContractDraft, ErrorCatcher) {
    //             return ContractDraft.get({ create: true }).$promise
    //             .then((data) => {
    //                 const civMapping = {
    //                     'm.': 'M.',
    //                     'mme': 'Mme',
    //                     'monsieur': 'M.',
    //                     'madame': 'Mme',
    //                 }
    //                 return _.assign({}, data, _.omitBy($stateParams, _.isNil), {
    //                     civ: _.get(civMapping, _.toLower($stateParams.civ), 'M.'),
    //                     utm_source: $stateParams.utm_source,
    //                     utm_medium: $stateParams.utm_medium,
    //                     utm_campaign: $stateParams.utm_campaign,
    //                 })
    //             }).catch((error) => {
    //                 ErrorCatcher.catchError(error)
    //                 return $q.reject(error)
    //             })
    //         },
    //     },
    //     data: {
    //         pageTitle: 'Souscription',
    //         isPartnerSubscription: true,
    //     },
    // })
    .state('landscape', {
        url: '/landscape?id',
        template: require('../states/landscape/landscape.jade')(),
        controller: 'landscapeCtrl',
        resolve: {
            contractDraft($q, $stateParams, ContractDraft, ErrorCatcher) {
                return ContractDraft.get({}).$promise
                .then((data) => {
                    return data
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.reject(error)
                })
            },
        },
        data: {
            pageTitle: 'Landscape',
        },
    })
    .state('subscriptionEnd', {
        parent: 'home',
        url: '/souscription/fin',
        template: require('../states/subscriptionEnd/subscriptionEnd.jade')(),
        controller: 'subscriptionEndCtrl',
        params: {
            email: null,
        },
        resolve: {
            enabledFeature($q, $state, featuresService) {
                return featuresService.getFeaturesPromise().then((dataFeature) => {
                    if (!dataFeature.subscriptionShowroom) {
                        $state.go('landing')
                        return $q.reject()
                    }
                })
            },
        },
        data: {
            pageTitle: 'Souscription',
            permissions: {
                only: [
                    'anonymous',
                ],
                redirectTo: 'landing',
            },
        },
    })
    .state('landingOffrePrintemps2018', {
        parent: 'home',
        url: '/offreAchatGroupePrintemps2018?civ&givenname&sn&mail&id_prm&id_ref_promo',
        template: require('../states/subscriptionLanding/landingOffrePrintemps2018.jade')(),
        controller: 'landingOffrePrintemps2018Ctrl',
        resolve: {
            enabledFeature($q, $state, featuresService) {
                return featuresService.getFeaturesPromise().then((dataFeature) => {
                    if (!dataFeature.subscriptionOffrePrintemps2018) {
                        $state.go('landing')
                        return $q.reject(false)
                    }
                    return $q.resolve(true)
                })
            },
        },
    })
    .state('landingOffreRentree2018', {
        parent: 'home',
        url: '/offreAchatGroupeRentree2018?civ&givenname&sn&mail&id_prm&ville&prep',
        template: require('../states/subscriptionLanding/landingOffreRentree2018.jade')(),
        controller: 'landingOffreRentree2018Ctrl',
        resolve: {
            enabledFeature($q, $state, ContractDraft) {
                return ContractDraft.getOfferSelectable({ provider_offer: 'OFFRE_RENTREE_2018' }).$promise.then((selectableResult) => {
                    if (!selectableResult.selectable) {
                        $state.go('landing')
                        return $q.reject(false)
                    }
                    return $q.resolve(true)
                })
            },
        },
    })
    .state('subscriptionSummarySignup', {
        url: '/souscription/resume/:token',
        template: require('../states/subscriptionSummary/subscriptionSummary.jade')(),
        controller: 'subscriptionSummaryCtrl',
        resolve: {
            subscriptionToken($q, $state, $stateParams, User) {
                localStorage.removeItem('subscriptionToken')
                const { token } = $stateParams
                if (!token) {
                    redirectSelfcareV2()
                } else {
                    return User.getInfoByToken({ token }).$promise
                    .then((userInfo) => {
                        if (userInfo.type === 'SUBSCRIPTION') {
                            localStorage.subscriptionToken = token
                            return $q.resolve(token)
                        } else if (userInfo.active) {
                            $state.go('subscriptionSummary')
                            return $q.reject()
                        }
                        $state.go('confirm', { token })
                        return $q.reject()
                    })
                    .catch((error) => {
                        redirectSelfcareV2()
                        return $q.reject()
                    })
                }
            },
            contractDraft($state, $q, ContractDraft, ErrorCatcher, subscriptionToken /* subscriptionToken must be loaded before timeline */) {
                return ContractDraft.getByToken({ create: true, token: localStorage.subscriptionToken, notifySubscription: true }).$promise
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    $state.go('landing')
                    return $q.reject(error)
                })
                .then((contractDraft) => {
                    if (contractDraft.ready_to_checkout) {
                        return contractDraft
                    }
                    $state.go('landing')
                    return $q.reject()
                })
            },
            timeline($q, $state, ContractDraft, ErrorCatcher, contractDraft /* contractDraft must be loaded before timeline */) {
                return ContractDraft.getTimetableByToken({ token: localStorage.subscriptionToken }, {}).$promise
                .then((values) => timelineToGraphData(values))
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.resolve([])
                })
            },
        },
    })
    .state('subscriptionSummary', {
        url: '/souscription/resume',
        template: require('../states/subscriptionSummary/subscriptionSummary.jade')(),
        controller: 'subscriptionSummaryCtrl',
        resolve: {
            subscriptionToken() {
                return null
            },
            contractDraft($state, $q, ContractDraft, ErrorCatcher) {
                return ContractDraft.get({ create: true, withRelated: 'providerOffer,nextBillableDate' }).$promise
                .catch((error) => {
                    ErrorCatcher.catchError(error)
                    $state.go('landing')
                    return $q.reject(error)
                })
                .then((contractDraft) => {
                    if (contractDraft.ready_to_checkout) {
                        return contractDraft
                    }
                    $state.go('landing')
                    return $q.reject()
                })
            },
            timeline($q, $state, ContractDraft, ErrorCatcher, contractDraft /* contractDraft must be loaded before loading timeline */) {
                const fnGetTimetable = (contractDraft.estimated_v !== 0) ? 'getTimetableV2' : 'getTimetableV1'

                return ContractDraft[fnGetTimetable]().$promise
                .then((values) => timelineToGraphData(values)).catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.resolve([])
                })
            },
        },

        data: {
            pageTitle: 'Souscription',
            permissions: {
                only: [
                    'user',
                ],
                redirectTo: {
                    default: 'login',
                },
            },
        },
    })
    .state('anonPaymentSummary', {
        parent: 'home',
        url: '/regularisation/:tokenId',
        template: require('../states/anonPaymentSummary/anonPaymentSummary.jade')(),
        controller: 'anonPaymentSummaryCtrl',
        resolve: {
            paymentToken($state, $q, $stateParams, AnonPayment, ErrorCatcher) {
                return AnonPayment.getToken({ tokenId: $stateParams.tokenId }).$promise.catch((error) => {
                    return undefined
                })
            },
        },
        data: {
            pageTitle: 'Régularisation',
        },
    })
    .state('anonTerminationSummary', {
        parent: 'home',
        url: '/resiliation/:tokenId',
        template: require('../states/anonTerminationSummary/anonTerminationSummary.jade')(),
        controller: 'anonTerminationSummaryCtrl',
        resolve: {
            terminationToken($stateParams, AnonTermination, ErrorCatcher) {
                return AnonTermination.getTerminationToken({ tokenId: $stateParams.tokenId }).$promise.catch((error) => {
                    ErrorCatcher.catchError(error)
                    return undefined
                })
            },
            cancel() {
                return false
            },
        },
        data: {
            pageTitle: 'Confirmer la résiliation',
        },
    })
    .state('anonCancelTerminationSummary', {
        parent: 'home',
        url: '/annuler-resiliation/:tokenId',
        template: require('../states/anonTerminationSummary/anonTerminationSummary.jade')(),
        controller: 'anonTerminationSummaryCtrl',
        resolve: {
            terminationToken($stateParams, AnonTermination, ErrorCatcher) {
                return AnonTermination.getTerminationToken({ tokenId: $stateParams.tokenId }).$promise.catch((error) => {
                    ErrorCatcher.catchError(error)
                    return undefined
                })
            },
            cancel() {
                return true
            },
        },
        data: {
            pageTitle: 'Annuler la résiliation',
        },
    })
    .state('securityDepositAnonymous', {
        parent: 'home',
        url: '/depot-garantie/:tokenId',
        template: '<security-deposit-summary deposit-info="$ctrl.depositInfo" token-id="$ctrl.tokenId" contract-id="$ctrl.contractId"></security-deposit-summary>',
        controllerAs: '$ctrl',
        controller($stateParams, depositInfo) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            this.depositInfo = depositInfo
            this.tokenId = $stateParams.tokenId
            this.contractId = $stateParams.contractId
        },
        resolve: {
            depositInfo($stateParams, SecurityDeposit) {
                return SecurityDeposit.getToken({ tokenId: $stateParams.tokenId }).$promise.then((result) => {
                    return _.assign({}, result, {
                        tokenId: $stateParams.tokenId,
                        isDepositNeeded: true,
                    })
                }).catch(() => {
                    return undefined
                })
            },
        },
        data: {
            pageTitle: 'Dépôt de garantie',
        },
    })
    .state('securityDepositAuthenticated', {
        parent: 'home',
        url: '/depot-garantie/contrat/:contractId',
        template: '<security-deposit-summary deposit-info="$ctrl.depositInfo" token-id="$ctrl.tokenId" contract-id="$ctrl.contractId"></security-deposit-summary>',
        controllerAs: '$ctrl',
        controller($stateParams, depositInfo) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            this.depositInfo = depositInfo
            this.tokenId = $stateParams.tokenId
            this.contractId = $stateParams.contractId
        },
        resolve: {
            depositInfo($q, $state, $stateParams, Contract, ErrorCatcher) {
                return Contract.isDepositNeeded({ id: $stateParams.contractId }).$promise.catch((error) => {
                    ErrorCatcher.catchError(error)
                    return {}
                }).then((result) => {
                    if (result.depositNeeded === true) {
                        return $q.resolve({
                            contractId: $stateParams.contractId,
                            isDepositNeeded: result.depositNeeded,
                        })
                    } else if (result.depositNeeded === false) {
                        $state.go('landing')
                        return $q.reject()
                    }
                    return $q.resolve(undefined)
                })
            },
        },
        data: {
            pageTitle: 'Dépôt de garantie',
        },
    })
    .state('campaignLanding', {
        url: '/campagne/:id_campaign?tokenId',
        template: require('../states/campaignLanding/campaignLanding.jade')(),
        controller: 'campaignLandingCtrl',
        resolve: {
            currentCampaign(CampaignLanding, $state, $stateParams) {
                return CampaignLanding
                .getCampaign({
                    id_campaign: $stateParams.id_campaign,
                    tokenId: $stateParams.tokenId,
                })
                .$promise
                .catch((error) => $state.go('landing'))
            },
        },
    })
    .state('confirmNewsletter', {
        parent: 'home',
        url: '/newsletter/:newsletterId/:answer',
        template: require('../states/confirmNewsletter/confirmNewsletter.jade')(),
    })
    .state('quotationDefault', {
        parent: 'home',
        url: '/devis',
        resolve: {
        // This is a hack - Need to use angular-ui-router: 1.0.0 minimum for better redirectTo
            redirectTo($state, $q) {
                $state.go('quotation', { viewState: 'state-form-initial' })
                return $q.reject()
            },
        },
    })
    .state('quotation', {
        parent: 'home',
        url: '/devis/:viewState',
        template: '<quotation ' +
        'contract-draft="$ctrl.contractDraft" ' +
        'landscape-questions="$ctrl.landscapeQuestions" ' +
        'tariff-options="$ctrl.tariffOptions"' +
        'view-state="$ctrl.viewState">' +
        '</quotation>',
        controllerAs: '$ctrl',
        controller($stateParams, contractDraft, landscapeQuestions, tariffOptions) {
            // Remove template/controllerAs/controller and use component after upgrading to ui-router > 1.x
            const ctrl = this
            ctrl.contractDraft = contractDraft
            ctrl.landscapeQuestions = landscapeQuestions
            ctrl.tariffOptions = tariffOptions
            ctrl.viewState = $stateParams.viewState
        },
        resolve: {
            enabledFeature($q, $state, featuresService) {
                return featuresService.getFeaturesPromise()
                .then((dataFeature) => {
                    if (!dataFeature.quotation) {
                        $state.go('landing')
                        return $q.reject()
                    }
                    return true
                })
            },
            contractDraft(ContractDraft, ErrorCatcher, $q, enabledFeature) {
                if (enabledFeature) {
                    return ContractDraft.get({ create: true }).$promise
                    .catch((error) => {
                        ErrorCatcher.catchError(error)
                        return $q.reject(error)
                    })
                }
                return $q.reject()
            },
            landscapeQuestions($q, LandscapeQuestions, ErrorCatcher, contractDraft, enabledFeature) {
                if (enabledFeature) {
                    return LandscapeQuestions
                    .search({
                        category: 'c-est-parti',
                        id_contract: contractDraft.id,
                        draft: true,
                    })
                    .$promise
                    .catch((error) => {
                        ErrorCatcher.catchError(error)
                        return $q.reject(error)
                    })
                }
                return $q.reject()
            },
            tariffOptions($q, ReferencesService, ErrorCatcher, enabledFeature) {
                if (enabledFeature) {
                    return ReferencesService.getRefPromise('ot-ps')
                    .catch((error) => {
                        ErrorCatcher.catchError(error)
                        return $q.reject(error)
                    })
                }
                return $q.reject()
            },
        },
    })
    .state('callbackSlimpay', {
        parent: 'home',
        url: '/retour-slimpay?order_reference',
        resolve: {
            defaultRedirect($q, $state, $stateParams, AnonPayment, ErrorCatcher, Tokens) {
                const deferred = $q.defer()
                AnonPayment.getOrderReference({ order_reference: $stateParams.order_reference }).$promise.then((orderReference) => {
                    if (orderReference.bulk_purchase === 'ufc') {
                        if (orderReference.checkout_method === 'VENDOR') {
                            $state.go('vendorSignatureConfirmation', {
                                order_reference: $stateParams.order_reference,
                                transactionId: $stateParams.order_reference,
                                transactionStatus: orderReference.success ? 'success' : 'failure',
                            })
                        } else {
                            Tokens.getSignupToken({ token: localStorage.bulkPurchaseSubscriptionToken }, {}).$promise
                            .then((tokenResponse) => {
                                $state.go('confirm', {
                                    token: tokenResponse.token,
                                    transactionId: $stateParams.order_reference,
                                    transactionStatus: orderReference.success ? 'success' : 'failure',
                                    bulk_purchase: orderReference.bulk_purchase,
                                })
                            })
                            .catch((error) => {
                                if (error.status === 409) {
                                    $state.go('login', {
                                        order_reference: $stateParams.order_reference,
                                        transactionId: $stateParams.order_reference,
                                        transactionStatus: orderReference.success ? 'success' : 'failure',
                                        bulk_purchase: orderReference.bulk_purchase,
                                    })
                                }
                                return ErrorCatcher.catchErrorWithoutRedirect(error)
                            })
                        }
                    } else if (orderReference.type === 'MANDATE') {
                        $state.go('endSubscription', {
                            order_reference: $stateParams.order_reference,
                            transactionId: $stateParams.order_reference,
                            transactionStatus: orderReference.success ? 'success' : 'failure',
                            bulk_purchase: orderReference.bulk_purchase,
                        })
                    } else if (orderReference.type === 'MANDATE_RESIGNATURE') {
                        $state.go('mandateConfirmation', {
                            order_reference: $stateParams.order_reference,
                            transactionId: $stateParams.order_reference,
                            transactionStatus: orderReference.success ? 'success' : 'failure',
                            bulk_purchase: orderReference.bulk_purchase,
                        })
                    } else {
                        $state.go('paymentConfirmation', {
                            order_reference: $stateParams.order_reference,
                            transactionId: $stateParams.order_reference,
                            transactionStatus: orderReference.success ? 'success' : 'failure',
                            bulk_purchase: orderReference.bulk_purchase,
                        })
                    }

                    deferred.reject()
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    $state.go('paymentConfirmation', { order_reference: $stateParams.order_reference, error, bulk_purchase: localStorage.bulkPurchaseSubscriptionToken ? 'ufc' : '' })
                    deferred.reject()
                })
                return deferred.promise
            },
        },
    })
    .state('endSubscription', {
        parent: 'home',
        url: '/confirmation-souscription?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference',
        template: require('../states/endSubscription/endSubscription.jade')(),
        controller: 'endSubscriptionCtrl',
        resolve: {
            contractDraft($q, ContractDraft, ErrorCatcher) {
                let getContractDraftPromise
                if (localStorage.subscriptionToken) {
                    getContractDraftPromise = ContractDraft.getByToken({ create: false, silent: true, token: localStorage.subscriptionToken }).$promise
                } else {
                    getContractDraftPromise = ContractDraft.get({ create: false, silent: true }).$promise
                }
                return getContractDraftPromise.catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.reject(error)
                })
            },
            isDepositNeeded($q, $state, $stateParams, Contract, User, ErrorCatcher) {
                const transactionContractId = _.get($stateParams, 'transactionId', _.get($stateParams, 'order_reference', '')).split('-')[0]
                let isDepositNeededPromise
                if (localStorage.subscriptionToken) {
                    isDepositNeededPromise = Contract.isDepositNeededByToken({ token: localStorage.subscriptionToken }).$promise
                } else if (!_.isEmpty(transactionContractId)) {
                    isDepositNeededPromise = Contract.isDepositNeeded({ id: transactionContractId }).$promise
                } else {
                    // unknown transactionContractId, will check first contract in endSubscription
                    isDepositNeededPromise = $q.resolve({ depositNeeded: false })
                }
                return isDepositNeededPromise.then((isDepositResult) => {
                    if (isDepositResult.depositNeeded) {
                        if (localStorage.subscriptionToken) {
                            $state.go('securityDepositAnonymous', { tokenId: localStorage.subscriptionToken, contractId: transactionContractId })
                        } else {
                            $state.go('securityDepositAuthenticated', { contractId: transactionContractId })
                        }
                        return $q.reject()
                    }
                    return $q.resolve({ contractId: transactionContractId, depositNeeded: isDepositResult.depositNeeded })
                }).catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.reject(error)
                })
            },
            isSlimpaySuccess($q, $state, $stateParams, contractDraft) {
                const transactionContractId = _.get($stateParams, 'transactionId', _.get($stateParams, 'order_reference', '')).split('-')[0]
                if (($stateParams.transactionStatus === 'failure') || ((contractDraft.id === transactionContractId) && contractDraft.ready_to_checkout)) {
                    $state.go('endSubscriptionSlimpayFailure', $stateParams)
                    return $q.reject()
                }
                return $q.resolve()
            },
            shouldRedirectToLoginPage($q, $state, $stateParams, User, ErrorCatcher, isDepositNeeded, isSlimpaySuccess) {
                if (localStorage.subscriptionToken) {
                    return User.getInfoByToken({ token: localStorage.subscriptionToken }).$promise.then((userInfo) => {
                        if (userInfo.active) {
                            $state.go('login', _.assign({}, $stateParams, { redirectTo: 'endSubscription' }))
                            return $q.reject()
                        }
                        $state.go('confirm', _.assign({}, $stateParams, { token: localStorage.subscriptionToken, redirectTo: 'endSubscription' }))
                        return $q.reject()
                    }).catch((error) => {
                        ErrorCatcher.catchError(error)
                        return $q.reject(error)
                    })
                }
            },
            userInfo($q, ApiService, ErrorCatcher, shouldRedirectToLoginPage /* required to be executed before userInfo */) {
                return ApiService.fetchUserInfo().catch((error) => {
                    ErrorCatcher.catchError(error)
                    return $q.reject(error)
                })
            },
        },
        data: {
            pageTitle: 'Souscription',
        },
    })
    .state('endSubscriptionSlimpayFailure', {
        parent: 'home',
        url: '/erreur-souscription?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference',
        template: require('../states/endSubscription/endSubscriptionSlimpayError.jade')(),
        controller: 'endSubscriptionSlimpayErrorCtrl',
    })
    .state('mandateConfirmation', {
        parent: 'home',
        url: '/confirmation-mandat?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference&cardOperationResult',
        template: '<mandate-confirmation transaction="$ctrl.transaction"></mandate-confirmation>',
        controllerAs: '$ctrl',
        controller($stateParams) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            const ctrl = this
            ctrl.transaction = {
                transactionStatus: $stateParams.transactionStatus,
                transactionErrorCode: $stateParams.transactionErrorCode,
                signatureOperationResult: $stateParams.signatureOperationResult,
                transactionId: $stateParams.transactionId,
                order_reference: $stateParams.order_reference,
                cardOperationResult: $stateParams.cardOperationResult,
            }
        },
    })
    .state('vendorSignatureConfirmation', {
        parent: 'home',
        url: '/confirmation-signature-vendor?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference&cardOperationResult',
        template: '<vendor-signature-confirmation transaction="$ctrl.transaction"></vendor-signature-confirmation>',
        controllerAs: '$ctrl',
        controller($stateParams) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            const ctrl = this
            ctrl.transaction = {
                transactionStatus: $stateParams.transactionStatus,
                transactionErrorCode: $stateParams.transactionErrorCode,
                signatureOperationResult: $stateParams.signatureOperationResult,
                transactionId: $stateParams.transactionId,
                order_reference: $stateParams.order_reference,
                cardOperationResult: $stateParams.cardOperationResult,
            }
        },
    })
    .state('paymentConfirmation', {
        parent: 'home',
        url: '/confirmation-paiement?transactionStatus&transactionErrorCode&signatureOperationResult&transactionId&order_reference&cardOperationResult',
        template: '<payment-confirmation transaction="$ctrl.transaction"></payment-confirmation>',
        controllerAs: '$ctrl',
        controller($stateParams, transaction) {
            // remove template / controllerAs / controller and replace by component after migrating to angular-ui-router >= 1.0.0
            const ctrl = this
            ctrl.transaction = _.assign({}, transaction, {
                transactionStatus: $stateParams.transactionStatus,
                transactionErrorCode: $stateParams.transactionErrorCode,
                signatureOperationResult: $stateParams.signatureOperationResult,
                transactionId: $stateParams.transactionId,
                order_reference: $stateParams.order_reference,
                cardOperationResult: $stateParams.cardOperationResult,
            })
        },
        resolve: {
            transaction($q, $stateParams, ErrorCatcher, AnonPayment, DataAccessVariables, PermPermissionStore) {
                if (_.isEmpty($stateParams.transactionId)) {
                    return $q.resolve({})
                }
                const transactionResult = {
                    transactionStatus: $stateParams.transactionStatus,
                    transactionId: _.defaultTo($stateParams.transactionId, $stateParams.order_reference),
                }
                if ($stateParams.transactionId.split('_')[0] === 'DEPOSIT') {
                    return DataAccessVariables.get({ variables: 'DEPOSIT_AMOUNT' }).$promise.then((response) => {
                        return _.assign({}, transactionResult, { payment: { amount: response.DEPOSIT_AMOUNT } })
                    }).catch((error) => {
                        ErrorCatcher.catchError(error)
                        return transactionResult
                    })
                }
                return PermPermissionStore.getStore().client.validatePermission().then(() => {
                    return AnonPayment.getOrderReference({ order_reference: $stateParams.order_reference }).$promise
                    .catch((error) => {
                        ErrorCatcher.catchError(error)
                        return $q.reject(error)
                    })
                }).catch(() => {
                    return transactionResult
                })
            },
        },
    })
    .state('templateInfo', {
        url: '/template/info',
        template: '<template-info></template-info>',
        resolve: {
            isEnabled($q, $window) {
                if ($window.location.host.indexOf('local') > -1 || $window.location.host.indexOf('int') > -1) {
                    return $q.resolve()
                }
                return $q.reject()
            },
        },
    })


    $urlRouterProvider.otherwise('/')

    $locationProvider.html5Mode(true).hashPrefix('!')

    // Should set to true but need to apply catch on every promise
    return $qProvider.errorOnUnhandledRejections(false)
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/config/routes.js